import ApiService from "@/core/services/ApiService";

class SportService {

    //lista de instituciones
    public static getData(params) {
        ApiService.setHeader()
        return ApiService.post('api/sports',params)
    }

    public static save(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/sports/save', data)
    }

    public static edit(id: string) {
        ApiService.setHeader()
        return ApiService.get(`api/sports/${id}`, 'edit')
    }

    public static update (id, data) {
        ApiService.setHeader()
        return ApiService.put(`api/sports/${id}/update`,data)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/sports/${id}`, 'delete')
    }

    public static getDetails(data: any) {
        ApiService.setHeader()
        return ApiService.get('api/sports', data)
    }

    public static getClosure(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/closure', data)
    }

    //configuracion
    public static getSetting(){
        ApiService.setHeader()
        return ApiService.get('api/sports', 'setting')
    }

    public static getParams(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/sports/params', data)
    }

    public static getTest(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/sports/test', data)
    }

}

export default SportService;